
import { createSlice } from "@reduxjs/toolkit";
import { IStudentGradesSlice } from "../../../models/student/studentGrades";

const initialStudentSubjectGradeState: IStudentGradesSlice = {
    grades: undefined,
  };
  
  const studentSubjectGradesSlice = createSlice({
    name: "earlyAlerts",
    initialState: initialStudentSubjectGradeState,
    reducers: {
      setStudentSubjectGrades: (state, action: { payload: any }) => {
        state.grades = action.payload;
      },
    },
  });
  
  export const { setStudentSubjectGrades } = studentSubjectGradesSlice.actions;
  
  const studentSubjectGradesReducer = studentSubjectGradesSlice.reducer;
  
  export type studentSubjectGradesState = ReturnType<typeof studentSubjectGradesReducer>;
  
  export default studentSubjectGradesReducer;